import EnumReferralRewardType from "./EnumReferralRewardType";
import EnumReferralTrigger from "./EnumReferralTrigger";

export default class UpsertReferralRuleRequest {
  RuleId?: number = null;
  Trigger: EnumReferralTrigger = null;
  Threshold: number = 0;
  WindowDays?: number = null;
  RewardType: EnumReferralRewardType = null;
  RewardDays?: number = null;

  constructor(obj?: Partial<UpsertReferralRuleRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
